import { render, staticRenderFns } from "./LegalModal.vue?vue&type=template&id=7dbb3a29&scoped=true"
import script from "./LegalModal.vue?vue&type=script&lang=ts"
export * from "./LegalModal.vue?vue&type=script&lang=ts"
import style0 from "./LegalModal.vue?vue&type=style&index=0&id=7dbb3a29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbb3a29",
  null
  
)

export default component.exports